import AddIcon from '@mui/icons-material/Add';
import { Box, Divider, Paper } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';

import InfoUser from '../InfoUser';
import useStyles from './styles';

const CustomPaperSearchUser = ({
  onClickPaper,
  isShowCustomPaper = true,
  onClickSelectSaveUser,
  titleSaveUser,
  listSavedUser = [],
  ...props
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  // Separate connected vs manual
  const connectedList = listSavedUser.filter((item) => item.connected_artist);
  const manualList = listSavedUser.filter((item) => !item.connected_artist);

  const handleSelect = (handler, item) => () => handler && handler(item);

  return (
    <Paper {...props}>
      {props.children}
      {isShowCustomPaper && (
        <div>
          <Box>
            {/* Connected Artist Section */}
            {connectedList.length > 0 && (
              <>
                <Text
                  className={classes.titleConnectedUser}
                  fontWeightBold
                >
                  {t('connected_artist_list')}
                </Text>
                {connectedList.map((item, idx) => {
                  const artist = item.connected_artist;
                  return (
                    <Box
                      key={`connected-${idx}`}
                      className={classes.wrapSavedUser}
                      onMouseDown={handleSelect(onClickSelectSaveUser, item)}
                    >
                      <InfoUser
                        user={artist}
                        isShowClearIcon={false}
                      />
                    </Box>
                  );
                })}
              </>
            )}

            {/* Manually Added Artist Section */}
            {manualList.length > 0 && (
              <>
                <Text
                  className={classes.titleSavedUser}
                  fontWeightBold
                >
                  {titleSaveUser}
                </Text>
                {manualList.map((item, idx) => (
                  <div
                    key={`manual-${idx}`}
                    className={classes.wrapSavedUser}
                    onMouseDown={handleSelect(onClickSelectSaveUser, item)}
                  >
                    <Text>{item.saved_user?.legal_name || item.name_saved_user}</Text>
                    <Text className={classes.textEmailOrPhone}>
                      {item.saved_user?.email ||
                        item.saved_user?.phone_number ||
                        item.contact_info_saved_user}
                    </Text>
                    <Divider style={{ marginTop: '5px' }} />
                  </div>
                ))}
              </>
            )}
          </Box>

          {/* Add Manually Button */}
          <Box
            className={classes.wrapBoxContent}
            onMouseDown={() => onClickPaper()}
          >
            <div className={classes.wrapItem}>
              <AddIcon />
              <Text
                className={classes.text}
                fontWeightBold
              >
                {t('add_owner_manually')}
              </Text>
            </div>
          </Box>
        </div>
      )}
    </Paper>
  );
};

export default CustomPaperSearchUser;
